export default "__VITE_ASSET__BrrZTOly__"